 AOS.init({
  duration: 1200,
})

// New Code Start Here **//

 jQuery(document).on('ready', function() {
  $(".all_wrap.active").hide();
  $('buy-buttons.buy-buttons').after('<input type="hidden" class="addwarranty" data-val=""  >');

$(document).on("click", ".open-drop-wranty", function (event) {
    $(this).toggleClass("active");
    $('.boxes-wrranty').removeClass('active');
    $('.boxes-wrranty:nth-child(1)').addClass('active');
    if ($(this).hasClass("active")) {
     // console.log('have active class');
      $(".all_wrap").removeClass("active");
      $(".all_wrap").show(500);
    }else{
      //console.log('not active class');
      $(".all_wrap").addClass("active");
      $(".all_wrap.active").hide(500);
    }
});

$(document).on("click", ".boxes-wrranty:nth-child(1)", function (event) {
    //  $('.open-drop-wranty').trigger('click');
      $('.boxes-wrranty').removeClass('active');
      $(this).addClass('active');
      var Price =  $(".price-list sale-price").attr("data-price");
      var totPrice = "£"+Price;
      $(".price-list sale-price ").html(`<span class="sr-only">Sale price</span> ${totPrice}`);
      $('.klarna-sec .klarnacontent').text('Pay in 3 instalments of £23');
      $('.clearpay-sec .klarnacontent').text('Pay in 4 instalments of £17.50');
     $('input.addwarranty').attr('data-val','single-warranty');
})

$(document).on("click", ".boxes-wrranty:nth-child(2), .boxes-wrranty:nth-child(3)", function (event) {
 // $('.open-drop-wranty').trigger('click');
    $('.boxes-wrranty').removeClass('active');
    $(this).addClass('active');
    var Price = $(this).find(".price").text();
    var newPrice = parseFloat(Price.replace(/[^0-9.]/g, ""));
    console.log(newPrice);
    var pro_price = $(".price-list sale-price").attr("data-price");
    console.log(pro_price);
    var subPrice =  parseFloat(newPrice) + parseFloat(pro_price);
    var allTotalPrice = subPrice.toFixed(2);
    console.log(allTotalPrice);
    var totPrice = "£"+allTotalPrice;
    $(".price-list sale-price ").html(`<span class="sr-only">Sale price</span> ${totPrice}`);

    var klarnaPrice = (allTotalPrice / 3).toFixed(2);
    var clearPayprice = (allTotalPrice / 4).toFixed(2);
    console.log(klarnaPrice);
    console.log(clearPayprice);
    $('.klarna-sec .klarnacontent').text('Pay in 3 instalments of £'+klarnaPrice);
    $('.clearpay-sec .klarnacontent').text('Pay in 4 instalments of £'+clearPayprice);

    var dataval = $(this).find('.box-content-wrantty').attr('data-val');
    var datavarIds = $(this).find('.box-content-wrantty').attr('data-varid');
    $('input.addwarranty').attr('data-val',dataval);
    $('input.addwarranty').attr('data-varid',datavarIds);

});


$(document).on('click', '.color-swatch', function (event) {
    $('.boxes-wrranty:nth-child(1)').trigger('click');
});

//

  
jQuery(document).on("click", 'buy-buttons.buy-buttons button[type="submit"]', function (event) {
 // $('.open-drop-wranty').trigger('click');
  var dataWrranty =  $('input.addwarranty').attr('data-val');
    if( dataWrranty =='' || dataWrranty =='single-warranty'){
     }else{
       setTimeout(function () {
         var vrId = $('input.addwarranty').attr('data-varid');
        console.log('now add to cart');
        console.log(vrId);
        jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data:{id:vrId,quantity: 1 },
        dataType: 'json',
        success: function(data) {
      console.log(data);
      console.log('successfully');
        },
      });
      //console.log('here 95 line');
         
       }, 800);
    }
    
    
});

		

  });
// *** End New Code Start Here **//
 // progress bars
 function progressBar(className,countTo){
    jQuery(className).each(function() {
    let percent = jQuery(this).attr('data-value');
     percent =  countTo;
  if(percent > 100){
    percent = 100;
  } 
  jQuery(this).animate({width: percent+'%' }, 3000);
});

    
   //  });
   
    }


  // count number
   function numberCounter(className){
     jQuery(className).each((i, el) => {
    var $counter = jQuery(el);
    if (!$counter.isInViewport() || $counter.data('animation-started'))
      return;
      $counter.data('animation-started', true).prop('Counter', 0).animate({
      Counter: $counter.text()
        
    }, {
      duration: 3000,
      easing: 'swing',
      step: function(now) {
        $counter.text(Math.ceil(now));
      
        }
       });
     });
  }

// Checks if any particular element is in viewport
jQuery.fn.isInViewport = function() {
  var elementTop = jQuery(this).offset().top;
  var elementBottom = elementTop + jQuery(this).outerHeight();
  var viewportTop = jQuery(window).scrollTop();
  var viewportBottom = viewportTop + jQuery(window).height();
  return elementTop < viewportBottom;
};
 jQuery(window).scroll(function(){
 //     if(jQuery(window).scrollTop() >= jQuery('.cstm_thumbgallery').offset().top + jQuery('.cstm_thumbgallery').height() || jQuery(window).scrollTop() > jQuery('.cstm_thumbgallery').offset().top)
 //       {
     numberCounter('.air-iconstxt .prose .heading_prose h2');
     
 //       }
      });

   jQuery(window).scroll(function(){
      if(jQuery(window).scrollTop())
      {
     numberCounter('.right-left-img-1 .content-progress-bar h2 span');
       progressBar(".right-left-img-1 .first-bar .progressbar .bar","100");
      progressBar(".right-left-img-1 .second-bar .progressbar .bar","50");
      }
 
  
      });
   jQuery(window).scroll(function(){
     if(jQuery(window).scrollTop())
       {
        numberCounter('.right-left-img-2 .content-progress-bar h2 span');
         progressBar(".right-left-img-2 .show_for_desktop .first-bar .progressbar .bar","60");
          progressBar(".right-left-img-2 .show_for_desktop .second-bar .progressbar .bar","100");
            progressBar(".right-left-img-2 .show_for_mobile .first-bar .progressbar .bar","100");
          progressBar(".right-left-img-2 .show_for_mobile .second-bar .progressbar .bar","50");
       }
      });

     jQuery(window).scroll(function(){
     if(jQuery(window).scrollTop())
       {
           numberCounter('.right-left-img-3 .content-progress-bar h2 span');
           numberCounter('.elite-right-left-img-3 .content-progress-bar h2 span');
          // numberCounter('.right-left-img-3-4-mob .top-left-img-section .content-progress-bar h2 span');
          // numberCounter('.right-left-img-3-4-mob .right-image-section .content-progress-bar h2 span');
          // progressBar(".elite-right-left-img-3 .first-bar .progressbar .bar","100");
          // progressBar(".elite-right-left-img-3 .second-bar .progressbar .bar","50");
          // progressBar(".right-left-img-3-4-mob .first-bar .progressbar .bar","100");
          // progressBar(".right-left-img-3-4-mob .second-bar .progressbar .bar","40");
       }
      });

  
     jQuery(window).scroll(function(){
     if(jQuery(window).scrollTop() >= jQuery('.right-left-img-3').offset().top + jQuery('.right-left-img-3').height() || jQuery(window).scrollTop() > jQuery('.right-left-img-3').offset().top)
       {
          // numberCounter('.right-left-img-4 .content-progress-bar h2 span');
          // progressBar(".right-left-img-4 .first-bar .progressbar .bar","100");
          // progressBar(".right-left-img-4 .second-bar .progressbar .bar","40");
       }
      });
     jQuery(window).scroll(function(){
     if(jQuery(window).scrollTop() >= jQuery('.right-left-img-6').offset().top + jQuery('.right-left-img-6').height() || jQuery(window).scrollTop() > jQuery('.right-left-img-6').offset().top)
        {
        jQuery('.right-left-img-7 .content-progress-bar h2 span').each((i, el) => {
    var $counter = jQuery(el);
    if (!$counter.isInViewport() || $counter.data('animation-started'))
      return;

    $counter.data('animation-started', true).prop('Counter', 0).animate({
      Counter: $counter.text()
    }, {
      duration: 2000,
      easing: 'swing',
      step: function(now) {
        $counter.text(Math.ceil(now)+'%');
      }
    });
  });
        }
      });
  





//scroller animation
   function scrollerFunctionBottom(count1,count2,classname){

      var classElement = $(classname);
      if ($(window).scrollTop() >= count1 && $(window).scrollTop() <= count2 ) {
               
       var scrollTop = $(window).scrollTop();
            var off = classElement.offset().top
         classElement.data('orig-offset', off);

            var off = classElement.data('orig-offset');
            var translate =  (scrollTop - off) / scrollTop * 100;
            var translateFinal = translate * 2;
           
            classElement.css({transform: 'translateY(' + -translateFinal +'px)'});
                    }
  
   }
   function scrollerFunctionTop(count1,count2,classname){
               var classElement = $(classname);
//console.log($(window).scrollTop())
                 if ($(window).scrollTop() >= 3300  ) {
                      numberCounter('.right-left-img-1 .content-progress-bar h2 span');
                     progressBar(".right-left-img-1 .first-bar .progressbar .bar","100");
        progressBar(".right-left-img-1 .second-bar .progressbar .bar","50");
                 }
 
      if ($(window).scrollTop() >= 4500) {
        numberCounter('.right-left-img-3 .content-progress-bar h2 span');
          numberCounter('.elite-right-left-img-3 .content-progress-bar h2 span');
      
          progressBar(".elite-right-left-img-3 .first-bar .progressbar .bar","100");
          progressBar(".elite-right-left-img-3 .second-bar .progressbar .bar","50");
        
      } 
     if($(window).scrollTop() >= 5000){
         numberCounter('.right-left-img-4 .content-progress-bar h2 span');
          progressBar(".right-left-img-4 .first-bar .progressbar .bar","100");
          progressBar(".right-left-img-4 .second-bar .progressbar .bar","40");
     }
     
   if ($(window).scrollTop() >= count1 && $(window).scrollTop() <= count2 ) {
                  var scrollTop = $(window).scrollTop();
               var off = classElement.offset().top
              classElement.data('orig-offset', off);
              var off = classElement.data('orig-offset');
            var translate =  (scrollTop - off) / scrollTop * 100;

             var translateFinal = translate * 2;
            classElement.css({transform: 'translateY(' + translateFinal +'px)'});
         } }
   function scrollerFunctionRightLeft(count1,count2,classname){
               var classElement = $(classname);
          if ($(window).scrollTop() >= count1 && $(window).scrollTop() <= count2 ) {
                  var scrollTop = $(window).scrollTop();
               var off = classElement.offset().top
              classElement.data('orig-offset', off);
              var off = classElement.data('orig-offset');
            var translate =  (scrollTop - off) / scrollTop * 100;
             var translateFinal = translate * 2;
                   
            classElement.css({transform: 'translateX(' + -translateFinal +'px)'});
         } }
   function scrollerFunctionLeftRight(count1,count2,classname){
               var classElement = $(classname);
                 if ($(window).scrollTop() >= count1 && $(window).scrollTop() <= count2 ) {
                  // console.log($(window).scrollTop())
                  var scrollTop = $(window).scrollTop();
               var off = classElement.offset().top
              classElement.data('orig-offset', off);
              var off = classElement.data('orig-offset');
            var translate =  (scrollTop - off) / scrollTop * 100;
             var translateFinal = translate * 2;
              // var translateFinal = translate * 2;
                  // console.log(translateFinal)
                 //  console.log(translate)
            classElement.css({transform: 'translateX(' + translateFinal +'px)'});
         } }


     var getWindowWidth = $( window ).width();
            if(getWindowWidth > 767){
              
       $(window).scroll(function(){
           scrollerFunctionBottom('2600','3800','#scroll-effect-img1');
         
   if ($(window).scrollTop() >= 4000) {
          numberCounter('.right-left-img-2 .content-progress-bar h2 span');
          progressBar(".right-left-img-2 .show_for_desktop .first-bar .progressbar .bar","60");
          progressBar(".right-left-img-2 .show_for_desktop .second-bar .progressbar .bar","100");
          progressBar(".right-left-img-2 .show_for_mobile .first-bar .progressbar .bar","100");
          progressBar(".right-left-img-2 .show_for_mobile .second-bar .progressbar .bar","50");
      }
                      });
               $(window).scroll(function(){
           scrollerFunctionTop('3500','4600','#scroll-effect-img2');
                      });
                   $(window).scroll(function(){
                 
           scrollerFunctionBottom('4000','5600','#scroll-effect-img3');
             
                      });
                   $(window).scroll(function(){
           scrollerFunctionTop('5000','6600','#scroll-effect-img4');
                      });

            }
 if(getWindowWidth < 767){
   jQuery('.img-txt-section.air-imgtxt_first.top-left-img-section.show_for_desktop').remove();

    jQuery('.img-txt-section.air-imgtxt_first.right-image-section.show_for_desktop').remove();
     
  $(window).scroll(function(){
     scrollerFunctionTop('2400','3400','#scroll-effect-img1');
                      });
     $(window).scroll(function(){
     scrollerFunctionBottom('3000','3800','#scroll-effect-img2');
        if ($(window).scrollTop() >= 3000) {
          numberCounter('.right-left-img-2 .content-progress-bar h2 span');
          progressBar(".right-left-img-2 .show_for_desktop .first-bar .progressbar .bar","60");
          progressBar(".right-left-img-2 .show_for_desktop .second-bar .progressbar .bar","100");
          progressBar(".right-left-img-2 .show_for_mobile .first-bar .progressbar .bar","100");
          progressBar(".right-left-img-2 .show_for_mobile .second-bar .progressbar .bar","50");
      }
                      });
        $(window).scroll(function(){
     scrollerFunctionLeftRight('3600','4200','#scroll-effect-img-left-3-4');
                    if ($(window).scrollTop() >= 4000) {
                         numberCounter('.right-left-img-3-4-mob .top-left-img-section .content-progress-bar h2 span');
          numberCounter('.right-left-img-3-4-mob .right-image-section .content-progress-bar h2 span');
          progressBar(".right-left-img-3-4-mob .first-bar .progressbar .bar","100");
          progressBar(".right-left-img-3-4-mob .second-bar .progressbar .bar","40");
                       }
                      });
    $(window).scroll(function(){
     scrollerFunctionRightLeft('4000','4600','#scroll-effect-img-right-3-4');
                      });
 }
 